
import { Pipe, PipeTransform } from '@angular/core';
// import { TranslationService } from '@services/Translate.service';
import { TranslationService } from '@services/translate.service';
@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {
  constructor(private translation: TranslationService) {}

  transform(key: string): string {
    return this.translation.get(key);
  }
}